const doExamHelper = {
    methods: {
        /**
         * 根据服务端返回的分数，发布条件返回最终要显示的分数状态
         * @param serverScore 服务端返回的分数，有可能显示为已交卷
         * @param scorePublish 考试设置的发布条件
         * @param publishTime 发布时间
         * @return {string} this.scoreStates
         */
        getScoreState(serverScore, scorePublish, publishTime) {
            const getStateByScore = () => {
                return serverScore === "已交卷" ? this.scoreStates.noScore : this.scoreStates.showScore
            }
            scorePublish = parseInt(scorePublish)
            if (scorePublish === 3) { // 立即发布
                return getStateByScore();
            } else if (scorePublish === 2) { // 指定时间发布
                let now = new Date().getTime();
                publishTime = new Date(publishTime.replace(/-/g, "/")).getTime();
                if (now >= publishTime) {
                    return getStateByScore();
                } else {
                    return this.scoreStates.noTime;
                }
            } else { // 永不发布
                return this.scoreStates.neverPub
            }
        },
        // 重新设置选项的序号
        resetAnswerRank(question) {
            let rank = 1;
            question.SubjectAnswerData.forEach(answer => {
                answer.RankNum = rank;
                rank++;
            })
        },
    },
    computed: {
        scoreStates() {
            return {
                noScore: "noScore", // 有主观题，无分数
                noTime: "noTime", // 没到时间
                neverPub: "neverPub", // 永不发布
                showScore: "showScore" // 显示分数
            }
        }
    },
}

export default doExamHelper
